/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/User/SavedOrderCart',[
    'jquery',
    'lodash',
    'global/all',
    'modules/Cart/all'
], function ($, _, Roc, Cart) {
    'use strict';

    var viewModel = {};

    var btns = {
        loadSavedCart: '[data-roc-action="loadSavedCart"]',
        removeSavedCart: '[data-roc-action="removeSavedCart"]'
    };

    /* Helpers UI */

    function showEmptyResultsMsg() {
        Roc.UI.template('#noEntryMsg-Tmp', { message: 'You do not have any saved carts.' }).then(function (renderedTemplate) {
            $(viewModel.targetSelector).html(renderedTemplate);
        });
    }

    function checkEmptyResultsMsg() {
        if ($(viewModel.listSel + ' .item').length === 0) {
            showEmptyResultsMsg();
        }
    }

    function removeFromUi(listSel, noResultsSel, editId) {
        $(listSel + ' .item[data-id=' + editId + ']').hide('slow', function () {
            $(this).remove();
            checkEmptyResultsMsg();
        });
    };

    /* Events */

    function removeSavedCartEvt() {
        $(document)
            .off('click', btns.removeSavedCart)
            .on('click', btns.removeSavedCart, function (e) {

                var cartId = $(this).parents('.item').attr('data-id');
                var deleteButton = $(e.currentTarget);

                Roc.Core.lockButton(deleteButton);

                Roc.UI.confirm({
                    "title": 'Delete Confirmation',
                    "message": 'Are you sure you want to delete this item?',
                    "buttons": {
                        "Yes": {
                            "class": 'btn btnAction confirm',
                            "autoClose": true,
                            "action": function () {
                                Cart.CartManager.removeSavedCart(cartId);
                            }
                        },
                        "No": {
                            "class": 'btn',
                            "action": function () {
                                Roc.Core.releaseLockedButton(deleteButton);
                            }
                        }
                    }
                });
        });

        Roc.EventManager.bind(Roc.Events.cart.CART_REMOVED, function (xhr) {
            if (xhr.status === 200 || xhr.status === 204) {
                removeFromUi('#saved-carts', '#noSavedCartsMsg', xhr.cartId);
            } else {
                Roc.UI.ajaxErrorPopup(xhr);
            }
        });
    };

    function loadSavedCartEvt() {
        $(document)
            .off('click', btns.loadSavedCart)
            .on('click', btns.loadSavedCart, function (e) {

                var cartId = $(this).parents('.item').attr('data-id');
                var loadButton = $(e.currentTarget);

                Roc.Core.lockButton(loadButton);

                Roc.UI.confirm({
                    "title": 'Load List',
                    "message": 'Do you want your cart to be replaced with the available item(s)?',
                    "buttons": {
                        "Continue": {
                            "class": 'btn btnAction confirm',
                            "autoClose": false,
                            "action": function () {
                                Cart.CartManager.loadSavedCart(cartId, {
                                    beforeSend: function() {
                                        Roc.Core.lockButton('.btn.btnAction.confirm');
                                    }
                                });

                                $.each(viewModel.orderCarts, function (index, value) {
                                    if (value.id === cartId) {
                                        Roc.EventManager.notify(Roc.Events.cart.LOAD_SAVED_CART, value.items);
                                    }
                                });
                            }
                        },
                        "Cancel": {
                            "class": 'btn',
                            "action": function () {
                                Roc.Core.releaseLockedButton(loadButton);
                            }
                        }
                    }
                });
        });

        function filterOutMessagesForDisplay(response) {
            var errors = 0;
            if (response.messages > 0) {
                _.each(response.addCartItemsResponse, function (response) {
                    response.errors = response.errors || [];
                     //Customization to display all error messages rather than filter them out
                    //response.errors = _.filter(response.errors, function (e) {
                    //    return e.errorMessage !== 'Sorry, this item is no longer available.';
                    //});
                    errors += response.errors.length;
                });
                response.messages = errors;
            }
            return errors === 0;
        }

        Roc.EventManager.bind(Roc.Events.cart.CART_LOADED, function (xhr) {
            var response = xhr.responseJSON || {};
            var redirectToCart = response.orderId && filterOutMessagesForDisplay(response);
            if (redirectToCart) {
                window.location.href = '/cart';
            } else {
                if (response.messages > 0) {
                    var model = {};
                    model.heading = response.cart ? 'Your cart have been loaded with problems:' :
                        'Problems occurred during your request and we were not able to load your cart.';
                    model.responses = response.addCartItemsResponse;
                    
                    Roc.UI.template('#serviceErrors-Tmp', model).then(function (renderedTemplate) {
                        $('#confirmBox').html(renderedTemplate);
                    });

                    $('#confirmButtons .btn.btnAction.confirm').remove();
                    $('#confirmButtons .btn').text('Continue');
                } else {
                    Roc.UI.ajaxErrorPopup(xhr, response.message);
                    Roc.Core.releaseLockedButton('.btn.btnAction.confirm');
                }
            }
        });
    };

    function closeDetailsEvt() {
        Roc.UI.onCloseFormEvt(viewModel.listSel + ' .item', function (ctx) {
            var id = $(ctx).attr('id');
            $('.btn[aria-controls=' + id + ']').text('Show Cart');
        });
    }

    function openDetailsEvt() {
        Roc.UI.onOpenFormEvt(viewModel.listSel + ' .item', function (ctx) {
            var id = $(ctx).attr('id');
            $('.btn[aria-controls=' + id + ']').text('Hide Cart');
        });
    }

    function checkReorderStatus() {
        _.forEach(viewModel.orderCarts, function (order) {
            var availableItems = _.filter(order.items, function (i) {
                return i.product.canAddProduct;
            });
            order.allowToReorder = (availableItems.length > 0);
            order.canRemoveCart = viewModel.rocUserId === order.userId;
        });
    }

    function bindEvents() {
        removeSavedCartEvt();
        loadSavedCartEvt();
        closeDetailsEvt();
        openDetailsEvt();
    }

    /* Init */

    function loadCarts() {
        if (viewModel.orderCarts.length) {
            checkReorderStatus();
            // Customization: Add products sfsNumber to view model
            _.forEach(viewModel.orderCarts, function (o) {
                _.forEach(o.recipients,
                function (r) {
                    _.forEach(r.items,
                        function (item) {
                            Roc.ProductHelper.setProductSFSNumber(item);
                        });
                    });
            });
            //END Customization
            Roc.UI.template('#savedOrderCart-Tmp', viewModel).then(function (renderedTemplate) {
                $(viewModel.targetSelector).html(renderedTemplate);
            });
        } else {
            showEmptyResultsMsg();
        }
    }

    function init(model) {
        viewModel = model;
        viewModel.targetSelector = '#savedOrderCartWiget';
        viewModel.listSel = '#saved-carts';
        loadCarts();
        bindEvents();
    };

    var SavedOrderCart = {
        init: init,
        viewModel: viewModel
    };

    Roc.Logger.debug('SavedOrderCart.js Loaded:', SavedOrderCart);

    return SavedOrderCart;
});
